import UsersAdministration from 'features/admin/users/UsersAdministration';

const UsersAdministrationPage = () => <UsersAdministration />;

export default UsersAdministrationPage;
